import en from './myVaroStrings.en';

export default {
  en,
};
